export class FooterInfo {
  start = 0;
  end = 0;
  total = 0;
  selectedNumber = 0;
}
